import React, { useState, useEffect } from 'react'
import { useSnackbar } from 'notistack';
import { Grid, Button, TextField, Paper, Table, TableBody, TableCell, TableHead, TableRow, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress, Tooltip, Checkbox, Radio, RadioGroup } from '@material-ui/core';
import { DeletePopUp, PageLoader, STableLoader,AutocompleteCreatable } from '../../shared_elements'
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { globalGetService, globalPostService, globalPutService, globalDeleteService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import { regexConstants } from '../../../constants/regEx';
import InfoIcon from '@material-ui/icons/Info';
import ConfigData from '../master/components/ConfigData';
import { avationPlcInstance, jetStreamInstance, mtInstance,hanwahaInstance } from '../../../shared/components';
import AddIcon from '@material-ui/icons/Add';
import {EmptyCollection} from '../../shared_elements';
import ReadMoreInline from '../../../shared/components/ReadMoreInline';
const AddEditOwner = ({ addEditOwner, toggleModalFn, getResponseBack }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
 
    const toEmailOptions = (value) => typeof value === 'string'
        ? value.split(',').map(email => email.trim()).filter(Boolean).map(email => ({ inputValue: email, label: `Add ${email}` }))
        : (Array.isArray(value) ? value : []);

    const [owner, setOwner] = useState(!jetStreamInstance
        ? { ...addEditOwner.data, cc_address: toEmailOptions(addEditOwner?.data?.cc_address), reply_to: toEmailOptions(addEditOwner?.data?.reply_to) }
        : addEditOwner.data)
   
    const onFieldChange = (key, value) => {
        setOwner({ ...owner, [key]: value })
    }

    const onAddEditOwner = () => {
        let validationInputs = {
            name: owner?.name?.trim()?.length ? '' : 'Please enter Name',
            contact_fax: owner?.contact_fax?.trim()?.length ? regexConstants.fax.test(owner.contact_fax) ? '' : 'Please enter valid Fax number' : '',
            contact: owner?.contact?.trim()?.length ? regexConstants.email.test(owner.contact) ? '' : 'Please enter valid Email Address' : '',
            contact_phone_number: owner?.contact_phone_number?.trim()?.length ? regexConstants.phoneNumber.test(owner.contact_phone_number) ? '' : 'Please enter valid Phone number' : '',
            // contact: owner?.contact?.trim()?.length ? '' : 'Please enter valid Contact (Email and Phone)'
        }
       
        const getEmail = (item) => typeof item === 'string' ? item : (item?.inputValue || item?.value || item?.label || '');
        if (!jetStreamInstance) {
            if (owner?.cc_address.length) {
                let errorEmails = [];
                owner.cc_address.map(item => {
                    if (!regexConstants.email.test(item.inputValue)) {
                        errorEmails.push(item.inputValue);
                    }
                });
                if (errorEmails.length) {
                    validationInputs = {
                        ...validationInputs,
                        cc_address: `Please enter valid emails for "${errorEmails.join(',')}"`
                    }
                }
            }
             if (owner?.reply_to.length) {
                let errorEmails = [];
                owner.reply_to.map(item => {
                    if (!regexConstants.email.test(item.inputValue)) {
                        errorEmails.push(item.inputValue);
                    }
                });
                if (errorEmails.length) {
                    validationInputs = {
                        ...validationInputs,
                        reply_to: `Please enter valid emails for "${errorEmails.join(',')}"`
                    }
                }
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            const payload = {
                ...owner,
                qb_company_id: owner?.qb_company_id || null,
                ...(!jetStreamInstance ? {
                    cc_address: owner?.cc_address?.length ? owner.cc_address.map(getEmail).join(',') : '',
                    reply_to: owner?.reply_to?.length ? owner.reply_to.map(getEmail).join(',') : '',
                } : {}),
            };
            if (owner.id) {
                globalPutService(`console/owner/${owner.id}/`, payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            toggleModalFn(); getResponseBack();
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        }
                        setLoading(false);
                    })
            } else {
                globalPostService(`console/owner/`, payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            toggleModalFn(); getResponseBack();
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        }
                        setLoading(false);
                    })
            }
        } else {
            setError(validationInputs)
        }
    }
    return (
        <Dialog
            open={addEditOwner.modal}
            className='console-management-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                {owner.id ? 'Edit' : 'Add'} {jetStreamInstance ? 'Owner/SPV' : 'Owner'} & {jetStreamInstance ? 'Lessor/Holdco' : 'Lessor'}
            </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid item md={6}>
                        <TextField
                            required
                            id='name'
                            label='Name'
                            value={owner?.name || ''}
                            fullWidth
                            error={error.name}
                            helperText={error?.name || ''}
                            margin="normal"
                            onFocus={() => setError({ ...error, name: '' })}
                            onChange={(e) => onFieldChange('name', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            id='name'
                            label={
                                <div style={{ display: 'flex', alignItems: 'center' }}>Reference Name
                                    <Tooltip title={`If entered, Reference Name will appear in all invoices instead of Lessor/Owner Name.`} placement="top" arrow >
                                        <InfoIcon fontSize="small" style={{ verticalAlign: 'bottom', marginLeft: '3px' }} />
                                    </Tooltip>
                                </div>
                            }
                            value={owner?.reference_name || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('reference_name', e.target.value)}
                            InputLabelProps={{ shrink: true, style: { pointerEvents: "auto" } }}
                            variant='outlined'
                        />
                    </Grid>

                    <Grid item md={6}>
                        <TextField
                            id='address'
                            label='Address'
                            value={owner?.address || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('address', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            id='contact'
                            label={'Contact (Email)'}
                            inputProps={{ maxLength: 50 }}
                            value={owner?.contact || ''}
                            fullWidth
                            error={error.contact}
                            helperText={error?.contact || ''}
                            onFocus={() => setError({ ...error, contact: '' })}
                            margin="normal"
                            onChange={(e) => onFieldChange('contact', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={6}>
                            <TextField
                                id='contact'
                                label='Contact (Phone)'
                                inputProps={{ maxLength: 50 }}
                                value={owner?.contact_phone_number || ''}
                                fullWidth
                                error={error.contact_phone_number}
                                helperText={error?.contact_phone_number || ''}
                                onFocus={() => setError({ ...error, contact_phone_number: '' })}
                                margin="normal"
                                onChange={(e) => { const phoneNumber = e.target.value; if (phoneNumber === '' || regexConstants.numberWithSpecChar.test(phoneNumber)) { onFieldChange('contact_phone_number', phoneNumber); } }}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            id='contact_fax'
                            label='Contact Fax'
                            inputProps={{ maxLength: 20 }}
                            value={owner?.contact_fax ? owner?.contact_fax : null}
                            fullWidth
                            margin="normal"
                            // onBeforeInput={(e) => {if (!regexConstants.fax.test(e.data)) { e.preventDefault(); } }}
                            onChange={(e) => onFieldChange('contact_fax', (e.target.value).trimStart())}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            error={error.contact_fax}
                            helperText={error?.contact_fax || ''}
                            onFocus={() => setError({ ...error, contact_fax: '' })}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            id='country_of_incorporation'
                            label='Country of Incorporation'
                            value={owner?.country_of_incorporation || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('country_of_incorporation', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            id='jurisdiction'
                            label='Jurisdiction'
                            value={owner?.jurisdiction || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('jurisdiction', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                        />
                    </Grid>
                    {jetStreamInstance &&
                        <Grid item md={6}>
                            <TextField
                                id='qb_company_id'
                                label="QuickBooks Company ID"
                                value={owner?.qb_company_id || null}
                                fullWidth
                                margin="normal"
                                onChange={(e) => onFieldChange('qb_company_id', e.target.value.trimStart())}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                inputProps={{ maxLength: 20 }}
                            />
                        </Grid>
                    }
                    {hanwahaInstance ? <Grid item md={6}>
                        <TextField
                            id='legal_entity'
                            label='Legal Entity'
                            value={owner?.legal_entity || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('legal_entity', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            inputProps={{ maxLength: 15 }}
                        />
                    </Grid> : null}
                    {!jetStreamInstance ? <Grid item md={6}>
                        <TextField
                            id='display_name'
                            label='Display Name'
                            value={owner?.display_name || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('display_name', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid> : null}
                     {!jetStreamInstance ? <Grid item md={6}>
                         <AutocompleteCreatable
                                options={[]}
                                paramsKey='cc_address'
                                optionKey='label'
                                label='CC Address'
                                value={owner?.cc_address || []}
                                onFieldChange={(e, paramsKey, newValue) => onFieldChange('cc_address', newValue)}
                                // required={true}
                                resetErrorKey={() => setError({ ...error, cc_address: '' })}
                                multiple={true}
                                error={error.cc_address}
                                helperText={error?.cc_address || ''}
                            />
                    </Grid> : null}
                    {!jetStreamInstance ? <Grid item md={6}>
                        <AutocompleteCreatable
                            options={[]}
                            paramsKey='reply_to'
                            optionKey='label'
                            label='Reply To'
                            value={owner?.reply_to || []}
                            onFieldChange={(e, paramsKey, newValue) => onFieldChange('reply_to', newValue)}
                            // required={true}
                            resetErrorKey={() => setError({ ...error, reply_to: '' })}
                            multiple={true}
                            error={error.reply_to}
                            helperText={error?.reply_to || ''}
                        />
                    </Grid> : null}
                    <Grid item md={6}>
                        <TextField
                            id='vat_registration_number'
                            label='VAT Registration Number'
                            inputProps={{ maxLength: 50 }}
                            value={owner?.vat_registration_number ? owner?.vat_registration_number : ''}
                            fullWidth
                            margin="normal"
                            placeholder='Enter VAT Registration Number'
                            onChange={(e) => { const vatNumber = (e.target.value).trimStart(); if (vatNumber === '' || regexConstants.alphaNumericHyphenSpaceSlash.test(vatNumber)) { onFieldChange('vat_registration_number', vatNumber); } }}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onAddEditOwner} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const OwnerLessor = ({ }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [ownerList, setOwnerList] = useState([]);
    const [addEditOwner, setAddEditOwner] = useState({ modal: false, mode: '', data: null })
    const [deleteOwner, setDeleteOwner] = useState({ modal: false, data: null })
    useEffect(() => {
        getOwners('skeletonLoader');
    }, []);
    const getOwners = (loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/owner/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setOwnerList(response.data.data);
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onDeleteOwner = () => {
        setLoading(true);
        globalDeleteService(`console/owner/${deleteOwner.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteOwner({ modal: false, data: null })
                    getOwners('pageLoader');
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
                setLoading(false)
            })
    }
    return (
        <section className="config-container">
            <Paper className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content">
                    {checkPermission('config_data', 'owner_&_lessor', 'C') ?<Paper elevation={0} className='console-paper' style={{ textAlign: 'right',  padding: '4px 8px', marginBottom: "2px" }}>
                            <Button onClick={() => setAddEditOwner({ modal: true, mode: 'add', data: { name: '', address: '', contact: '', jurisdiction: '', contact_fax: null, reference_name: null } })} color='primary' size='small' variant='contained'><AddIcon style={{ fontSize: '1.15rem' }} /> Add {jetStreamInstance ? "Owner/SPV" : "Owner"} & {jetStreamInstance ? "Lessor/Holdco" : "Lessor"}</Button> 
                    </Paper> : null}
                    <Paper>
                        {skeletonLoader ? <STableLoader count={5} /> :
                            <Paper square>
                              <div style={{ height: `${window.innerHeight - 150}px`, overflow: 'auto' }}>
                                <Table className='mui-table-format' stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }}>Action(s)</TableCell>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Contact (Email)</TableCell>
                                            <TableCell>Contact (Phone No.)</TableCell>
                                            <TableCell>Contact Fax</TableCell>
                                            <TableCell>Address</TableCell>
                                            <TableCell>Country of Incorporation</TableCell>
                                            <TableCell>Jurisdiction</TableCell>
                                            <TableCell>Reference Name</TableCell>
                                            <TableCell>QuickBooks Company ID</TableCell>
                                            {hanwahaInstance ? <TableCell>Legal Entity</TableCell>: null}
                                            {!jetStreamInstance ? <TableCell>Display Name</TableCell> : null}
                                            {!jetStreamInstance ? <TableCell>CC Address</TableCell> : null}
                                            {!jetStreamInstance ? <TableCell>Reply To</TableCell> : null}
                                            <TableCell>VAT Registration Number</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ownerList?.map((item, index) =>
                                            <TableRow key={index}>
                                                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1, }}>
                                                    {checkPermission('config_data', 'owner_&_lessor', 'U') ?
                                                        <EditIcon style={{ cursor: 'pointer' }} onClick={() => setAddEditOwner({ modal: true, mode: 'edit', data: item })} color='primary' fontSize='small' /> : null
                                                    }
                                                    {checkPermission('config_data', 'owner_&_lessor', 'D') ?
                                                        <DeleteOutlineIcon style={{ cursor: 'pointer' }} onClick={() => setDeleteOwner({ modal: true, data: item })} color='secondary' fontSize='small' /> : null
                                                    }
                                                </TableCell>
                                                <TableCell><div style={{minWidth:'200px'}}>{item?.name || '--'}</div></TableCell>
                                                <TableCell><div style={{minWidth:'180px'}}>{item?.contact || '--'}</div></TableCell>
                                                <TableCell><div style={{minWidth:'160px'}}>{item?.contact_phone_number || '--'}</div></TableCell>
                                                <TableCell><div style={{minWidth:'160px'}}>{item?.contact_fax || '--'}</div></TableCell>
                                                <TableCell><div style={{minWidth:'250px'}}>{item?.address || '--'}</div></TableCell>
                                                <TableCell><div style={{minWidth:'180px'}}>{item?.country_of_incorporation || '--'}</div></TableCell>
                                                <TableCell><div style={{minWidth:'160px'}}>{item?.jurisdiction || '--'}</div></TableCell>
                                                <TableCell><div style={{minWidth:'180px'}}>{item?.reference_name || '--'}</div></TableCell>
                                                <TableCell><div style={{ minWidth: '160px' }}>{item?.qb_company_id || '--'}</div></TableCell>
                                                {hanwahaInstance ? <TableCell>{item?.legal_entity || '--'}</TableCell> : null}
                                                {!jetStreamInstance ? <TableCell style={{ minWidth: '160px' }}>{item?.display_name || '--'}</TableCell> : null}
                                                {!jetStreamInstance ? <TableCell style={{ minWidth: '210px' }}><ReadMoreInline text={item?.cc_address}/></TableCell> : null}
                                                {!jetStreamInstance ? <TableCell style={{ minWidth: '210px' }}><ReadMoreInline text={item?.reply_to}/></TableCell> : null}
                                                <TableCell><div style={{ minWidth: '160px' }}>{item?.vat_registration_number || '--'}</div></TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                                 {!ownerList.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title={'No records found'} /></div> : null}
                                 </div>
                            </Paper>
                        }
                    </Paper>
                </div>
            </Paper>
            {addEditOwner.modal ?
                <AddEditOwner
                    addEditOwner={addEditOwner}
                    toggleModalFn={() => setAddEditOwner({ modal: false, mode: '', data: null })}
                    getResponseBack={() => getOwners('pageLoader')}
                /> : null
            }
            {deleteOwner.modal ?
                <DeletePopUp
                    modal={deleteOwner.modal}
                    title={`Delete ${jetStreamInstance ? "Owner/SPV" : "Owner"} & ${jetStreamInstance ? "Lessor/Holdco" : "Lessor"}`}
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteOwner({ modal: false, data: null })}
                    deleteRecordFn={onDeleteOwner}
                /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}
export default OwnerLessor;